import { Popover } from 'antd'
import {
  CardsIconAmericanExpress,
  CardsIconDinersClub,
  CardsIconDiscover,
  CardsIconJcb,
  CardsIconMasterCard,
  CardsIconVisa,
} from 'Comps/svg'
import useI18n from 'Hooks/useI18n'

export default function FooterCardPopover() {
  const { t } = useI18n()
  return (
    <Popover
      trigger="hover"
      overlayInnerStyle={{
        background:
          'linear-gradient( 180deg, #180E1F 0%, #41234D 50%, #1D1515 100%)',
        backgroundColor: 'rgba(0,0,0,0.3)',
        border: '1px solid rgba(255,255,255,0.2)',
        padding: '0',
        borderRadius: '10px',
        opacity: '0.9',
      }}
      placement="topLeft"
      content={
        <div className="flex max-w-[227px] flex-wrap items-center gap-4 p-4">
          <CardsIconMasterCard />
          <CardsIconAmericanExpress />
          <CardsIconJcb />
          <CardsIconVisa />
          <CardsIconDinersClub />
          <CardsIconDiscover />
        </div>
      }
      arrow={false}
      className="max-md:hidden"
    >
      <div className="text-xs leading-[13px] text-white/50 hover:text-white">
        {t('Supported Cards')}
      </div>
    </Popover>
  )
}
